/* SSi website – German landing page hero. Mirrors SpanishHero.jsx — same A/B variants. */
import { Link } from 'react-router-dom';

export function GermanHero({ onStart, t }) {
  const variant = t.deHeroVariant || 'A';
  return variant === 'B'
    ? <GermanHeroB onStart={onStart} t={t}/>
    : <GermanHeroA onStart={onStart} t={t}/>;
}

function GermanHeroA({ onStart, t }) {
  return (
    <section className="ssi-deHero ssi-deHero--A" style={deHeroStyles.wrapA}>
      <div className="ssi-deHero__leftA" style={deHeroStyles.leftA}>
        {t.deHeroKicker && <div style={deHeroStyles.kicker}>{t.deHeroKicker}</div>}
        <h1 style={deHeroStyles.h1}>{t.deHeroTitle}</h1>
        <p style={deHeroStyles.lede}>{t.deHeroSub1}</p>
        <p style={deHeroStyles.lede}>{t.deHeroSub2}</p>
        <div style={deHeroStyles.ctas}>
          <Link to="/pay?course=en-de" className="btn btn--onDark">{t.deHeroCta1}</Link>
          <a href="#sample" className="btn" style={deHeroStyles.ghost}>{t.deHeroCta2}</a>
        </div>
        <p style={deHeroStyles.trust}>{t.deHeroTrust}</p>
      </div>
      <div className="ssi-deHero__rightA" style={deHeroStyles.rightA}>
        <img src="/assets/hero_couple_laughing.png?v=6" alt="" style={deHeroStyles.heroImg}/>
        <div className="ssi-deHero__bubble" style={deHeroStyles.bubble} aria-hidden>
          <span style={deHeroStyles.bubbleWord}>{t.deHeroBubble || "Hallo!"}</span>
          <span style={deHeroStyles.bubbleTail}/>
        </div>
      </div>
    </section>
  );
}

function GermanHeroB({ onStart, t }) {
  return (
    <section className="ssi-deHero ssi-deHero--B" style={deHeroStyles.wrapB}>
      <div className="ssi-deHero__innerB" style={deHeroStyles.innerB}>
        <div className="ssi-deHero__giantWrap" style={deHeroStyles.giantWrap}>
          <span style={deHeroStyles.giantTranslate}>(verb) to speak</span>
          <div style={deHeroStyles.giant} aria-hidden>{t.deHeroGiantWord}</div>
          <div style={deHeroStyles.giantUnderline}/>
        </div>
        <div style={deHeroStyles.copyB}>
          {t.deHeroKicker && <div style={deHeroStyles.kickerB}>{t.deHeroKicker}</div>}
          <h1 style={deHeroStyles.h1B}>{t.deHeroTitle}</h1>
          <p style={deHeroStyles.ledeB}>{t.deHeroSub1}</p>
          <p style={deHeroStyles.ledeB}>{t.deHeroSub2}</p>
          <div style={deHeroStyles.ctas}>
            <Link to="/pay?course=en-de" className="btn btn--onDark">{t.deHeroCta1}</Link>
            <a href="#sample" className="btn" style={deHeroStyles.ghost}>{t.deHeroCta2}</a>
          </div>
          <p style={deHeroStyles.trustB}>{t.deHeroTrust}</p>
        </div>
      </div>
    </section>
  );
}

const deHeroStyles = {
  kicker: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 18 },
  h1: { fontFamily: 'var(--font-display)', fontSize: 64, lineHeight: 1.04, color: '#fff', letterSpacing: '-.015em', margin: '0 0 20px', textWrap: 'balance' },
  lede: { fontSize: 18, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 18px', maxWidth: 540 },
  ctas: { display: 'flex', gap: 12, marginTop: 20, marginBottom: 24 },
  ghost: { background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,.5)' },
  trust: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
  wrapA: { background: 'var(--brandRed)', color: '#fff', padding: '88px 0 88px', position: 'relative', overflow: 'hidden', minHeight: 560 },
  leftA: { maxWidth: 600, padding: '0 32px', position: 'relative', zIndex: 2 },
  rightA: { position: 'absolute', right: 0, top: 0, bottom: 0, width: '50%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  heroImg: { width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center bottom' },
  bubble: { position: 'absolute', left: 'calc(10% )', top: 64, background: "#FFD84D", color: '#490300', padding: '18px 28px 22px', borderRadius: 18, transform: 'rotate(-5deg)', boxShadow: '0 18px 40px -14px rgba(0,0,0,.35), 0 2px 0 rgba(0,0,0,.08)', zIndex: 3 },
  bubbleWord: { fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 52, lineHeight: 1, letterSpacing: '-.02em', display: 'inline-block', fontStyle: 'italic' },
  bubbleTail: { position: 'absolute', left: 36, bottom: -12, width: 22, height: 22, background: "#FFD84D", borderBottomLeftRadius: 4, borderStyle: 'solid', borderWidth: '0 0 2px 2px', borderColor: 'transparent', transform: 'rotate(-45deg)' },
  wrapB: { background: 'var(--brandRed)', color: '#fff', padding: '80px 0 88px', position: 'relative', overflow: 'hidden' },
  innerB: { maxWidth: 1240, margin: '0 auto', padding: '0 32px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'center' },
  giantWrap: { position: 'relative' },
  giantTranslate: { display: 'inline-block', fontSize: 13, color: 'rgba(255,255,255,.7)', letterSpacing: '.02em', fontStyle: 'italic', marginBottom: 4, marginLeft: 4 },
  giant: { fontFamily: 'var(--font-display)', fontSize: 'clamp(96px, 13vw, 200px)', lineHeight: .95, fontWeight: 700, letterSpacing: '-.03em', color: '#fff', margin: 0 },
  giantUnderline: { width: 80, height: 4, background: '#FFD84D', borderRadius: 4, marginTop: 20, marginLeft: 4 },
  copyB: { maxWidth: 520 },
  kickerB: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 16 },
  h1B: { fontFamily: 'var(--font-display)', fontSize: 44, lineHeight: 1.1, color: '#fff', letterSpacing: '-.015em', margin: '0 0 18px', textWrap: 'balance' },
  ledeB: { fontSize: 16.5, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 16px', maxWidth: 520 },
  trustB: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
};
